<template>
  <div style="margin: 10px 0px">

    <span style="color: #909399;padding: 10px 0px">资源类型：</span>
    <el-radio @change='change' style="padding: 10px 0px" v-for="(item,index) in resourceTypes" v-bind:key="item.key" v-model="radio" :label="item.key">{{item.value}}</el-radio>
  </div>
</template>

<script>

  export default {
    name: 'Methods',
    methods:{
      change(val){
       this.$emit('change',val)
      }
    },
    mounted(){
      this.$emit('change',this.radio)
    },
    data () {
      let resourceTypes=[
        {key:'0',value:'后台菜单'},
        {key:"1",value:'后台按钮'},
        {key:"2",value:'前台权限'}
        ]
      return {
        resourceTypes:resourceTypes,
        radio:'0'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/main/permission/components/ResouceTypeComponent.vue